import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-elegirtaxtech',
  templateUrl: './elegirtaxtech.component.html',
  styleUrls: ['./elegirtaxtech.component.sass']
})
export class ElegirtaxtechComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
